module.exports = {"150271010":"稀土路街道","150271020":"民馨路街道","150271102":"万水泉镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150271.json
// module id = 499
// module chunks = 0